"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

var _chartHelper = require("./chartHelper");

var _excluded = ["width", "height", "data", "dataUnit", "dataKey", "layout", "legend", "bars", "xAxisOptions", "yAxisOptions", "gridOptions", "showGrid", "showXAxis", "showYAxis", "useDataColors", "brush", "tooltip"],
    _excluded2 = ["dataUnit", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var BarChart = function BarChart(props) {
  var width = props.width,
      height = props.height,
      data = props.data,
      dataUnit = props.dataUnit,
      dataKey = props.dataKey,
      layout = props.layout,
      legend = props.legend,
      bars = props.bars,
      xAxisOptions = props.xAxisOptions,
      yAxisOptions = props.yAxisOptions,
      gridOptions = props.gridOptions,
      showGrid = props.showGrid,
      showXAxis = props.showXAxis,
      showYAxis = props.showYAxis,
      useDataColors = props.useDataColors,
      brush = props.brush,
      tooltip = props.tooltip,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, null, /*#__PURE__*/_react.default.createElement(_recharts.BarChart, (0, _extends2.default)({
    layout: layout,
    width: width,
    height: height,
    data: data
  }, remainingProps), showGrid && /*#__PURE__*/_react.default.createElement(_recharts.CartesianGrid, (0, _extends2.default)({
    strokeDasharray: "3 3"
  }, (0, _chartHelper.mapGridOptions)(gridOptions))), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, (0, _extends2.default)({
    hide: !showXAxis,
    dataKey: dataKey
  }, xAxisOptions)), /*#__PURE__*/_react.default.createElement(_recharts.YAxis, (0, _extends2.default)({
    hide: !showYAxis,
    unit: dataUnit
  }, yAxisOptions)), legend && /*#__PURE__*/_react.default.createElement(_recharts.Legend, (0, _extends2.default)({
    payload: useDataColors && data.map(function (entry, index) {
      var legendColor = (0, _chartHelper.getColor)(entry.color) || (0, _chartHelper.getFromDefaultColors)(index);
      return _objectSpread(_objectSpread({}, entry), {}, {
        type: 'square',
        color: legendColor
      });
    })
  }, legend.props)), tooltip && /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
    cursor: {
      fill: _chartHelper.CURSOR_BACKGROUND_COLOR
    }
  }), bars.map(function (bar) {
    var _bar$props = bar.props,
        dataUnit = _bar$props.dataUnit,
        color = _bar$props.color,
        remainingBarProps = (0, _objectWithoutProperties2.default)(_bar$props, _excluded2);
    var cellColor = color && (0, _chartHelper.getColor)(color);
    return /*#__PURE__*/_react.default.createElement(_recharts.Bar, (0, _extends2.default)({
      key: bar.key,
      unit: dataUnit
    }, remainingBarProps, {
      fill: cellColor
    }), useDataColors && data.map(function (entry, index) {
      var cellColor = (0, _chartHelper.getColor)(entry.color) || (0, _chartHelper.getFromDefaultColors)(index);
      return /*#__PURE__*/_react.default.createElement(_recharts.Cell, {
        key: "cell-".concat(index),
        fill: cellColor
      });
    }));
  }), brush && /*#__PURE__*/_react.default.createElement(_recharts.Brush, {
    stroke: (0, _chartHelper.getColor)('gray')
  })));
};

BarChart.defaultProps = {
  width: 480,
  height: 200,
  data: [],
  // dataUnit,
  // dataKey,
  layout: 'horizontal',
  // legend,
  bars: [],
  // xAxisOptions,
  // yAxisOptions,
  // gridOptions,
  showGrid: false,
  showXAxis: true,
  showYAxis: true,
  useDataColors: false,
  brush: false,
  tooltip: true,
  legend: false
};
var _default = BarChart;
exports.default = _default;